import React, { useEffect, useState } from "react";
import ApiConfig from "../common/config/ApiConfig";
import MyTable from "./Table";
import { NavLink } from "react-router-dom";
import "./dashboard.css";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import { motion } from "framer-motion";
import Navbar from "./MemberNav";
import { CurrencyContext } from "../common/CurrencyContext";
import CalculateIcon from "@mui/icons-material/Calculate";
import moment from "moment";
import CreditImage from "../image/creditlorro.png";
import Innerdashboard from "./innerdashboard.jsx";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Footer from "./Footer";
import PlagiarismIcon from "@mui/icons-material/Plagiarism";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AnimateText from "./AnimateText";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import TopupCreditModal from "../Modals/TopupCreditModal";
import MemberWithdrawModal from "../Modals/MemberWithdrawModal";
import { useTranslation } from "react-i18next";
import useWebSocket from "../common/hooks/useWebSocket";

function DashboardContent() {
  const { t } = useTranslation();
  const user = localStorage.getItem("user");

  const json = { user: user };
  const [credit, setCredit] = useState();
  const [currency, setCurrency] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [ModalEventOpen, setModalEventOpen] = useState(false);
  const [Transaction, setTransaction] = useState([]);
  const [topupOpen, setTopupOpen] = useState(false);
  const [withdrawOpen, setWithdrawOpen] = useState(false);
  // console.log(Transaction)

  // The backend doesn't push any defined event payloads yet (see
  // docs/websocket_auth.md) — this just keeps an authenticated connection
  // alive for the dashboard session so real events can be wired in later.
  useWebSocket((data) => {
    console.log("[WS] message:", data);
  });

  const handleOpenEventModal = () => {
    setModalEventOpen(true);
  };
  const handleCloseEventModal = () => {
    setModalEventOpen(false);
  };
  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    // Make the POST request when the component mounts
    postData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const TransactionColumn = [
    {
      Header: t("dashboard.table.dateTime"),
      accessor: "date_time",
      align: "center",
      Cell: ({ value }) => (
        <span className="text-xs font-bold">
          {moment(value).format("DD-MM-YYYY | HH:mm:ss")}
        </span>
      ),
    },
    {
      Header: t("dashboard.table.amount"),
      accessor: "Amout",
      align: "right",
      Cell: ({ value }) => (
        <span
          className={`text-xs font-bold ${value < 0 ? "text-red-500" : "text-green-500"}`}
        >
          {value} {currency?.symbol}
        </span>
      ),
    },
    {
      Header: t("dashboard.table.note"),
      accessor: "Sender",
      align: "right",
      Cell: ({ value }) => (
        <span className="text-xs">
          {t("dashboard.table.actor")}{" "}
          <span className="text-xs font-bold"> :{value}</span>
        </span>
      ),
    },
  ];

  const postData = async () => {
    const jsonData = {
      user: user,
    };
    try {
      const responseData = await ApiConfig.post("/gettransaction", jsonData);
      if (responseData.resCode === 200) setTransaction(responseData.data);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  useEffect(() => {
    ApiConfig.post("/profile", json).then((result) => {
      if (result.resCode === 200) {
        setCredit(parseFloat(result.data.credit));
        setCurrency(result.data.currency ?? null);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Navbar username={user} balance={credit} />
      <div className="flex flex-col min-h-screen">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{
            opacity: 1,
            y: 0,
            scale: [1, 1.05, 1], // Scale animation effect
          }}
          transition={{
            duration: 1, // Duration of the animation
          }}
          className="inner_content flex-1"
        >
          <div className="flex flex-col xl:w-[75%]  w-[100%] h-auto p-2 rounded space-y-3">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{
                opacity: 1,
                y: 0,
                scale: [1, 1.05, 1], // Scale animation effect
              }}
              transition={{
                duration: 1, // Duration of the animation
              }}
              className="md:flex md:flex-row flex-col w-[100%] space-x-1 h-auto border border-brand-gold-300/40 p-1 bg-white bg-opacity-10 rounded-card"
            >
              <div className="flex justify-between flex-row md:w-[70%] bg-gradient-to-r from-brand-blue-900 via-brand-blue-800 to-brand-blue-700 rounded-card h-auto ">
                <div className="w-auto h-full flex-col p-2">
                  <div className="flex flex-row p-1 space-x-2">
                    <AccountBalanceWalletIcon className="text-white" />
                    <span className="text- text-white">
                      {t("dashboard.creditLabel")}{" "}
                    </span>
                    <span className="text- text-brand-gold-300">
                      {user && user}
                    </span>
                  </div>
                  <span className="text-[32px] font-bold font-heading text-brand-gold-300 ml-2 whitespace-nowrap">
                    {credit && Math.round(credit).toLocaleString("th-TH")}{" "}
                    {currency?.symbol}
                  </span>
                </div>
                <div className="w-auto h-full justify-left flex-col">
                  <img src={CreditImage} className="w-[150px]" alt="" />
                </div>
              </div>

              <div className="flex md:flex-col flex-row md:w-[30%] md:space-y-2 space-x-2 md:space-x-0 bg-white bg-opacity-10 h-auto p-2">
                <button
                  className="flex items-center justify-center gap-2 h-full w-full py-2 px-3 rounded-pill border-[3px] border-brand-blue-900 bg-gradient-to-b from-brand-gold-200 via-brand-gold-400 to-brand-gold-600 hover:from-brand-gold-100 hover:to-brand-gold-500 text-brand-ink-onGold font-heading font-extrabold shadow-gold active:scale-95 transition-all"
                  onClick={() => setTopupOpen(true)}
                >
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-brand-blue-900 shrink-0">
                    <AddCircleIcon
                      className="text-brand-gold-200"
                      sx={{ fontSize: 16 }}
                    />
                  </span>
                  <span className="whitespace-nowrap">
                    {t("dashboard.topup")}
                  </span>
                  <ChevronRightIcon
                    className="text-brand-blue-900"
                    fontSize="small"
                  />
                </button>
                <button
                  className="flex items-center justify-center gap-2 h-full w-full py-2 px-3 rounded-pill border-[3px] border-[#03142f] bg-gradient-to-b from-brand-blue-500 via-brand-blue-700 to-brand-blue-900 hover:from-brand-blue-400 hover:to-brand-blue-800 text-white font-heading font-extrabold shadow-md active:scale-95 transition-all"
                  onClick={() => setWithdrawOpen(true)}
                >
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-brand-gold-300 shrink-0">
                    <RemoveCircleIcon
                      className="text-brand-ink-onGold"
                      sx={{ fontSize: 16 }}
                    />
                  </span>
                  <span className="whitespace-nowrap">
                    {t("dashboard.withdraw")}
                  </span>
                  <ChevronRightIcon
                    className="text-brand-gold-300"
                    fontSize="small"
                  />
                </button>
              </div>
            </motion.div>
            <div className="md:flex flex-col w-[100%] space-y-3 h-auto mt-3 bg-gradient-to-r from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 border-2 border-brand-gold-300 rounded-card overflow-hidden">
              <AnimateText />
              <div className="md:bg-gradient-to-r from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 p-1 w-[100%] h-auto space-y-3 rounded-card">
                <div className="md:flex-row flex flex-wrap md:flex-nowrap md:w-[100%] p-1 text-center">
                  <NavLink className="md:w-full w-1/4" to="/dashboard" end>
                    {({ isActive }) => (
                      <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: 1,
                          y: 0,
                          scale: [1, 1.05, 1], // Scale animation effect
                        }}
                        transition={{
                          duration: 1, // Duration of the animation
                        }}
                        whileHover={{ y: -8, scale: 1.02 }}
                        style={{ height: "100% !important" }}
                      >
                        <div
                          className={`flex flex-col w-full h-auto justify-center items-center md:px-20 md:py-5 text-center rounded-lg transition-colors${isActive ? " bg-white/15 ring-2 ring-brand-gold-300 shadow-md" : " hover:bg-white/10"}`}
                        >
                          <CalculateIcon className="text-brand-gold-300" />
                          <span className="text-brand-gold-300 text-lg font-bold font-heading">
                            {t("dashboard.nav.bet")}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </NavLink>
                  <NavLink
                    className="md:w-full w-1/4"
                    to="/dashboard/orderlist"
                  >
                    {({ isActive }) => (
                      <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: 1,
                          y: 0,
                          scale: [1, 1.05, 1], // Scale animation effect
                        }}
                        transition={{
                          duration: 1, // Duration of the animation
                        }}
                        whileHover={{ y: -8, scale: 1.02 }}
                        style={{ height: "100% !important" }}
                      >
                        <div
                          className={`flex flex-col w-full h-auto justify-center items-center md:px-20 md:py-5 text-center rounded-lg transition-colors${isActive ? " bg-white/15 ring-2 ring-brand-gold-300 shadow-md" : " hover:bg-white/10"}`}
                        >
                          <PlagiarismIcon className="text-brand-gold-300 text-lg" />
                          <span className="text-brand-gold-300 text-lg font-bold font-heading">
                            {t("dashboard.nav.orders")}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </NavLink>
                  <NavLink className="md:w-full w-1/4" to="/dashboard/profile">
                    {({ isActive }) => (
                      <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: 1,
                          y: 0,
                          scale: [1, 1.05, 1], // Scale animation effect
                        }}
                        transition={{
                          duration: 1, // Duration of the animation
                        }}
                        whileHover={{ y: -8, scale: 1.02 }}
                        style={{ height: "100% !important" }}
                      >
                        <div
                          className={`flex flex-col w-full h-auto justify-center items-center md:px-20 md:py-5 text-center rounded-lg transition-colors${isActive ? " bg-white/15 ring-2 ring-brand-gold-300 shadow-md" : " hover:bg-white/10"}`}
                        >
                          <PersonSearchIcon className="text-brand-gold-300 text-lg" />
                          <span className="text-brand-gold-300 text-lg font-bold font-heading">
                            {t("dashboard.nav.profile")}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </NavLink>
                  <NavLink className="md:w-full w-1/4" to="/dashboard/result">
                    {({ isActive }) => (
                      <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: 1,
                          y: 0,
                          scale: [1, 1.05, 1], // Scale animation effect
                        }}
                        transition={{
                          duration: 1, // Duration of the animation
                        }}
                        whileHover={{ y: -8, scale: 1.02 }}
                        style={{ height: "100% !important" }}
                      >
                        <div
                          className={`flex flex-col w-full h-auto justify-center items-center md:px-20 md:py-5 text-center rounded-lg transition-colors${isActive ? " bg-white/15 ring-2 ring-brand-gold-300 shadow-md" : " hover:bg-white/10"}`}
                        >
                          <EmojiEventsIcon className="text-brand-gold-300 text-lg" />
                          <span className="text-brand-gold-300 text-lg font-bold font-heading">
                            {t("dashboard.nav.results")}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </NavLink>
                </div>
                <div className="flex flex-row w-[100%] space-x-2 h-auto">
                  <div
                    onClick={handleOpen}
                    className="w-[50%] flex rounded-lg overflow-hidden shadow-md cursor-pointer hover:-translate-y-0.5 transition-transform"
                  >
                    <div className="flex flex-row items-center justify-center md:w-[10%] w-[25%] bg-gradient-to-br from-brand-blue-800 to-brand-blue-900 p-2">
                      <RequestQuoteIcon className="text-brand-gold-200" />
                    </div>
                    <div className="bg-gradient-to-r from-brand-blue-600 to-brand-blue-700 md:w-[90%] w-[75%] p-2 text-center text-brand-gold-300 font-semibold font-heading hover:from-brand-blue-500 hover:to-brand-blue-600 transition-colors">
                      {t("dashboard.depositWithdrawList")}
                    </div>
                  </div>
                  <div className="w-[50%] flex rounded-lg overflow-hidden shadow-md cursor-pointer hover:-translate-y-0.5 transition-transform">
                    <div className="flex flex-row items-center justify-center md:w-[10%] w-[25%] bg-gradient-to-br from-brand-blue-700 to-brand-blue-800 p-2">
                      <LocalActivityIcon className="text-brand-gold-200" />
                    </div>
                    <div
                      onClick={handleOpenEventModal}
                      className="bg-gradient-to-r from-brand-blue-500 to-brand-blue-600 md:w-[90%] w-[75%] p-2 text-center text-brand-gold-300 font-semibold font-heading md:text-[16px] text-[14px] hover:from-brand-blue-400 hover:to-brand-blue-500 transition-colors"
                    >
                      {t("dashboard.newsAndEvents")}
                    </div>
                    <Dialog
                      open={ModalEventOpen}
                      onClose={handleCloseEventModal}
                      fullWidth
                      maxWidth="xs"
                    >
                      <DialogTitle className="bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800">
                        <LocalActivityIcon className="text-brand-gold-200" />
                        <span className="text-white ml-2">
                          {t("dashboard.newsAndEvents")}
                        </span>
                      </DialogTitle>
                      <DialogContent className="pt-3">
                        {currentPage === 1 && (
                          <div className="p-3" style={{ textAlign: "center" }}>
                            <img
                              src="/images/meesok.png"
                              alt="Advertisement 1"
                              style={{ width: "100%", height: "auto" }}
                            />
                            <br />
                            <h3>{t("dashboard.promotion.title1")}</h3>
                            <p>{t("dashboard.promotion.description")}</p>
                          </div>
                        )}
                        {currentPage === 2 && (
                          <div className="p-3" style={{ textAlign: "center" }}>
                            <img
                              className="rounded-m"
                              src="/images/meesok.png"
                              alt="Advertisement 1"
                              style={{ width: "100%", height: "auto" }}
                            />
                            <br />
                            <h3>{t("dashboard.promotion.title2")}</h3>
                            <p>{t("dashboard.promotion.description")}</p>
                          </div>
                        )}
                        {currentPage === 3 && (
                          <div className="p-3" style={{ textAlign: "center" }}>
                            <img
                              src="/images/meesok.png"
                              alt="Advertisement 1"
                              style={{ width: "100%", height: "auto" }}
                            />
                            <br />
                            <h3>{t("dashboard.promotion.title3")}</h3>
                            <p>{t("dashboard.promotion.description")}</p>
                          </div>
                        )}
                      </DialogContent>
                      <DialogActions>
                        {currentPage > 1 && (
                          <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            className="bg-brand-blue-600 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 rounded"
                          >
                            {t("dashboard.back")}
                          </button>
                        )}
                        {currentPage < 3 && (
                          <button
                            onClick={handleNextPage}
                            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                          >
                            {t("dashboard.next")}
                          </button>
                        )}
                        <button
                          onClick={handleCloseEventModal}
                          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                        >
                          x
                        </button>
                      </DialogActions>
                    </Dialog>
                  </div>
                  <Dialog
                    open={open}
                    onClose={handleCloseEventModal}
                    fullWidth
                    maxWidth="md"
                  >
                    <DialogTitle className="bg-brand-blue-800">
                      <FactCheckIcon className="text-brand-gold-200" />
                      <span className="text-white ml-2">
                        {t("dashboard.depositStatus")}
                      </span>
                    </DialogTitle>
                    <DialogContent>
                      {/* add your content here */}
                      <div className="w-[100%] mt-1 flex flex-col h-[100%] space-y-1">
                        <div className="md:flex flex-col w-[100%] bg-brand-blue-50 rounded-t border-black drop-shadow-xl">
                          <div className="flex flex-row bg-gradient-to-r from-brand-blue-800 to-brand-blue-700 rounded-t p-2 space-x-2">
                            <span className="text-white">
                              {t("dashboard.transactionHistory")}
                            </span>
                          </div>
                          <div className="p-2 border-black border-[1px]">
                            <MyTable
                              columns={TransactionColumn}
                              data={Transaction ?? []}
                            />
                          </div>
                        </div>
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <button
                        onClick={handleClose}
                        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                      >
                        {t("dashboard.closeWindow")}
                      </button>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
              <div></div>
            </div>
            <div className="md:flex flex-col w-[100%] h-auto bg-brand-blue-50 border-2 border-brand-gold-300 rounded-card shadow-cardLight">
              <div className="md:bg-brand-blue-100/40 p-1 w-[100%] h-auto space-y-3 rounded-card"></div>
              <div className="p-1">
                <CurrencyContext.Provider value={currency}>
                  <Innerdashboard balance={credit} className="" />
                </CurrencyContext.Provider>
              </div>
            </div>
          </div>
        </motion.div>
        <Footer />
      </div>
      <TopupCreditModal
        open={topupOpen}
        onClose={() => setTopupOpen(false)}
        currency={currency}
      />
      <MemberWithdrawModal
        open={withdrawOpen}
        onClose={() => setWithdrawOpen(false)}
        currency={currency}
      />
    </>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}
